import { LogService } from '@pershing/pershing-core';
import { Component, OnInit, Input, Output, EventEmitter, Optional, Inject } from '@angular/core';
import { TradeInfoForTaxlot, TaxlotSubmissionRequest, TaxlotDetailsRequest, UnitCostIndicator } from '../../../models/common/tax-lot.model';
import { RedemptionFeeWaiver, CDSCWaiver } from '../../../models/mutualfund/trading-mutualfund.model';
import { TradingDataService } from '../../../services/common/trading-data-service.service';
import { TradeType, TaxLotDetail, TransactionType } from '../../../models/common/trading-common.model';
import { TaxLotService } from '../../../services/tax-lot/tax-lot.service';
import { ALERT_MESSAGE_LEVEL, TAXLOT_DISPOSITION_METHOD_LIST, TAXLOT_DISPOSITION_METHOD_LIST_DISPLAY } from '../../../utils/trading-constants';
import { GridOptions, ClientSideRowModelModule, LicenseManager, Module } from '@ag-grid-enterprise/all-modules';
import { PershingGridHeaderComponent } from '@pershing/pershing-grid2';
import { DecimalPipe, registerLocaleData } from '@angular/common';
import { AlertMessageDialogComponent } from '../alert-message-dialog/alert-message-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { timer } from 'rxjs';
import { get } from 'lodash';
import {TradingEntitlements} from '../../../models/common/trading-entitlements';
import es from '@angular/common/locales/es';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tax-lot-grid',
  templateUrl: './tax-lot-grid.component.html',
  styleUrls: ['./tax-lot-grid.component.css'],
  providers: [DecimalPipe]
})
export class TaxLotGridComponent implements OnInit {
  @Input() tradeInfo: TradeInfoForTaxlot;
  @Input() availQty: number;
  @Input() baseCurrency: string;
  @Input() sellTaxlotID: string;
  @Input() isBdUser: boolean;
  @Input() tradingEntitlements: TradingEntitlements;
  @Input() activeTheme: string;
  @Output() submitSuccessEmitter = new EventEmitter<null>();
  public modules: Module[] = [ClientSideRowModelModule];
  taxlotType: string = 'disposition';   // 'disposition' or 'dateAndQty'

  defaultDispMethodCode: string;
  defaultDispMethodStr: string;
  defaultDispMethodReturnMessageText: string = '';

  dispMethodCode: string;
  get dispMethodStr(): string {
    if (!!this.dispMethodCode) {
      let dispMethodStr: string;
      const method = TAXLOT_DISPOSITION_METHOD_LIST.find(i => i.code === this.dispMethodCode);
      if ( !!method ) {
        dispMethodStr = (method.label || '');
      } else {
        dispMethodStr = '';
      }
      return dispMethodStr;
    }
    return '';
  }
  dispMethodList = TAXLOT_DISPOSITION_METHOD_LIST_DISPLAY;

  submissionErrors: any[];
  altMessage: string;
  isDriPPositionInd: boolean = false;
  showDisclaimer: boolean = false;
  // isDollarQty and isShareQty is used for Mutual Fund Taxlots
  isDollarQty: boolean = false;
  isShareQty: boolean = false;
  showConfirmButton: boolean = true;
  isSubmitFailed: boolean = false;
  showDisclaimer1: boolean = false;
  showDisclaimer2: boolean = false;
  showDisclaimerEquity3: boolean = false;
  showDisclaimerAvgCost4: boolean = false;
  showDisclaimerGiftCost5: boolean = false;
  showDisclaimerAvgDRIP6: boolean = false;
  isAllowMethodSelection: boolean = false;
  isAllowLotSelection: boolean = false;
  isAvgCost: boolean = false;
  // isOrdQtyis is used for Equity Taxlots
  isOrdQty: boolean = false;
  showOverallocationError: boolean = false;
  showMultipleAvgCostBucketSelectionError: boolean = false;

  taxLotDetails: TaxLotDetail[];
  rowData: any[];
  pinnedBottomRowData: any;
  totalRow: any;
  totalSelQty: number;
  totalSelectedRows: number = 0;
  isSell: boolean = false;
  isEditingInProgress: boolean = false;
  editCheckCount: number = 0;
  gridOptions: GridOptions;
  language: string = '';
  isSpinnerLoading: boolean = false;
  isRetail: boolean = false;
  showLesserQtyWarning: boolean = false;
  
  constructor(
    private tradingDataService: TradingDataService,
    private taxLotService: TaxLotService,
    private logService: LogService,
    private decimalPipe: DecimalPipe,
    public dialog: MatDialog,
    private translateService: TranslateService,
    @Optional() @Inject('AppSettings') appSettings: any
  ) {
    // App Settings is optional, so we need to do a NULL-safe operation here.
    if ( get(appSettings, 'agGridEnterpriseKey')) {
      LicenseManager.setLicenseKey(appSettings.agGridEnterpriseKey);
  }
    if (appSettings) {
    this.language = appSettings.language;
    if (this.language === 'es') {
       registerLocaleData( es );
    }
}

  }
  
  
  ngOnInit() {
    this.isRetail = this.tradingEntitlements.isRetailUser;
    if (this.tradingDataService.defaultDispositionMethodResp) {
      this.validateDefaultDispositionMethod();
    }
    this.validateTaxlotSubmited();
    this.setDollarShareOrd();
    this.fetchTaxlots();
    if (this.isRetail) {
      this.showDisclaimer = this.isRetail;
      this.setGridOptionsRetail();
    } else {
      this.setGridOptions();
    }
    this.setDisclaimers(false);
  }

  // validate the Default Disposition Method response
  private validateDefaultDispositionMethod(): void {
    
      if (this.tradingDataService.defaultDispositionMethodResp.returnCode === 0) {
        this.isDriPPositionInd = this.tradingDataService.defaultDispositionMethodResp.driPPositionInd === 'Y' ? true : false;
        this.isAllowMethodSelection = this.tradingDataService.defaultDispositionMethodResp.allowMethodSelectionInd === 'Y' ? true : false;
        this.isAllowLotSelection = this.tradingDataService.defaultDispositionMethodResp.allowLotSelectionInd === 'Y' ? true : false;

        // Make sure this block executes after the other flags are set,
        // in case we need to check the value of isDriPPositionInd or the other two flags
        if (this.tradingDataService.defaultDispositionMethodResp.defaultSellMethodCode) {
          this.defaultDispMethodCode = this.tradingDataService.defaultDispositionMethodResp.defaultSellMethodCode.trim().toUpperCase();
          this.isAvgCost = this.checkForAvgCostOrder();
          const method = TAXLOT_DISPOSITION_METHOD_LIST.find(i => i.code === this.defaultDispMethodCode);
          this.defaultDispMethodStr = method?.label ? method.label : '';
        }
      } else {
        this.defaultDispMethodReturnMessageText = this.tradingDataService.defaultDispositionMethodResp.returnMessageText;
        this.dispMethodList = null;
        this.showConfirmButton = false;
      }
  }

  // validate if taxlot was already submited
  private validateTaxlotSubmited(): void {
    if (!!this.tradingDataService.theTaxLot && !!this.tradingDataService.theTaxLot.sellMethodCode) {
      this.dispMethodCode = this.tradingDataService.theTaxLot.sellMethodCode;
    } else {
      this.dispMethodCode = this.defaultDispMethodCode;
    }
    this.tradingDataService.availableQty = this.availQty;

    if (this.tradeInfo.transactionType === TransactionType.SELL_FROM_PORTFOLIO || this.tradeInfo.transactionType === TransactionType.REDEEM) {
      this.isSell = true;
    }
  }

  private setDollarShareOrd(): void {
    //#region - taxlot grid
    if (this.tradeInfo.tradeType === TradeType.EQUITY || this.tradeInfo.tradeType === TradeType.OPTION) {
      this.isDollarQty = false;
      this.isShareQty = false;
      this.isOrdQty = true;
    } else if (this.tradeInfo.tradeType === TradeType.MUTUAL_FUND) {
      if (this.tradeInfo.tradeInShares === 'true') {
        this.isDollarQty = false;
        this.isShareQty = true;
        this.isOrdQty = false;
      } else {
        this.isDollarQty = true;
        this.isShareQty = false;
        this.isOrdQty = false;
      }
    }
  }

  // Set up our Grid options, including single-click edit (for the qty field), stopping editing when the grid
  // loses focus (to properly save any value entered if the user clicks "Confirm" without tabbing out of the field),
  // and our required event callbacks for cell click / edit completion.
  private setGridOptions(): void {
    this.gridOptions = {
      rowHeight: this.activeTheme == "compact" ? 26 : 46,
      headerHeight: this.activeTheme == "compact" ? 26 : 44,
      columnDefs: [
        {
          headerName: '', field: 'index',
          minWidth: this.activeTheme == "compact" ? 52 : 59,
          width: this.activeTheme == "compact" ? 52 : 59,
          headerClass: 'center', cellClass: 'center',
          cellRenderer: (param) => this.formatIndexColVal(param)
        },
        {
          headerName: 'TAX_LOT.TRADE_DATE', field: 'strPurchaseDate',
          minWidth: this.activeTheme == "compact" ? 101 : 110,
          width: this.activeTheme == "compact" ? 101 : 110,
          headerClass: 'center', cellClass: 'center',
          valueFormatter: (param) => this.formatStrPurchaseDateColVal(param)
        },
        {
          headerName: 'TAX_LOT.AVAILABLE_QUANTITY', field: 'availableQty',
          minWidth: 150,
          width: 150,
          type: 'numericColumn',
          valueFormatter: (param) => this.formatQtyColVal(param)
        },
        {
          headerName: 'TAX_LOT.SELECTED_QUANTITY',
          field: 'disposeQty',
          editable: (param) => this.isEditableDisposeQtyColVal(param),
          minWidth: this.activeTheme == "compact" ? 148 : 169,
          width: this.activeTheme == "compact" ? 148 : 169,
          type: 'numericColumn',
          cellRenderer: (param) => this.formatDisposeQtyColVal(param)
        },
        {
          headerName: 'TAX_LOT.REM_QTY', field: 'remainingQty',
          minWidth: this.activeTheme == "compact" ? 160 : 175,
          width: this.activeTheme == "compact" ? 160 : 175,
          type: 'numericColumn',
          valueFormatter: (param) => this.formatQtyColVal(param)
        },
        {
          headerName: 'TAX_LOT.UNIT_COST', field: 'unitCostAmt',
          minWidth: this.activeTheme == "compact" ? 98 : 139,
          width: this.activeTheme == "compact" ? 98 : 139,
          type: 'numericColumn',
          valueFormatter: (param) => this.formatUnitCostAmtColVal(param)
        },
        {
          headerName: 'TAX_LOT.COST_BASIS', field: 'totalCost',
          minWidth: this.activeTheme == "compact" ? 100 : 150,
          width: this.activeTheme == "compact" ? 100 : 150,
          type: 'numericColumn',
          valueFormatter: (param) => this.formatUnitCostAmtColVal(param)
        },
        {
          headerName: 'TAX_LOT.LOT_NUMBER', field: 'lotNo',
          minWidth: 150,
          width: 150,
          headerClass: 'center', cellClass: 'center'
        },
        // { headerName: 'TAX_LOT.SHORT_LONG_TERM', field: 'term', minWidth: 150, headerClass: 'center', cellClass: 'center' }
      ],
      singleClickEdit: true,
      stopEditingWhenGridLosesFocus: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
      onGridReady: (params) => { params.api.sizeColumnsToFit(); },
      onCellClicked: (event) => this.handleOnCellClicked(event),
      onCellEditingStarted: (event) => { this.isEditingInProgress = true; },
      onCellEditingStopped: (event) => this.handleOnCellEditingStopped(event)
    };
    this.gridOptions.defaultColDef = {
      resizable: true,
      headerComponentFramework: PershingGridHeaderComponent
    };
  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
  }
  // the new taxlot implementation for NXI requires a different order for the taxlot fields as well as additional fields,
  // created a separate method to set up the grid when the user is retail
  private setGridOptionsRetail(): void {
    this.gridOptions = {
      rowHeight: this.getWidth('rowGrid'),
      headerHeight: this.getWidth('headerGrid'),
      columnDefs: [
        {
          headerName: 'TAX_LOT.LOT_NUMBER', field: 'lotNo',
          minWidth: 110,
          width: 110,
          headerClass: 'center', cellClass: 'center'
        },
        {
          headerName: 'TAX_LOT.COVERED_NON_COVERED', field: 'coveredInd',
          minWidth: 90,
          width: 90,
          headerClass: 'left', cellClass: 'center',
          valueFormatter: (param) => this.formatCoveredInd(param)
        },
        {
          headerName: 'TAX_LOT.TRADE_DATE', field: 'strPurchaseDate',
          minWidth: this.getWidth('TRADE_DATE'),
          width: this.getWidth('TRADE_DATE'),
          headerClass: 'left', cellClass: 'center',
          valueFormatter: (param) => this.formatStrPurchaseDateColVal(param)
        },
        {
          headerName: 'TAX_LOT.AVAILABLE_QUANTITY', field: 'availableQty',
          minWidth: 100,
          width: 100,
          type: 'numericColumn',
          headerClass: 'qtyHeader',
          valueFormatter: (param) => this.formatQtyColVal(param)
        },
        {
          headerName: 'TAX_LOT.UNIT_COST', field: 'unitCostAmt',
          minWidth: this.getWidth('UNIT_COST'),
          width: this.getWidth('UNIT_COST'),
          type: 'numericColumn',
          // headerClass: 'right', cellClass: 'right',
          valueFormatter: (param) => {
            if ('00' === param.data.unitCostInd) {
              return '$' + this.formatUnitCostAmtColVal(param);
            } else {
              return this.formatUnitCostAmtColVal(param);
            }
          }
        },
        {
          headerName: 'TAX_LOT.COST_BASIS', field: 'totalCost',
          minWidth: this.getWidth('COST_BASIS'),
          width: this.getWidth('COST_BASIS'),
          type: 'numericColumn',
          valueFormatter: (param) => {
            if (param.value !== 'Total') {
              this.formatUnitCostAmtColVal(param);
            } else {
              return 'Total';
            }
          }
        },
        {
          headerName: 'TAX_LOT.SELECTED_QUANTITY',
          field: 'disposeQty',
          editable: (param) => this.isEditableDisposeQtyColVal(param),
          minWidth: this.getWidth('SELECTED_QUANTITY'),
          width: this.getWidth('SELECTED_QUANTITY'),
          type: 'numericColumn',
          cellRenderer: (param) => this.formatDisposeQtyColVal(param)
        },
        {
          headerName: 'TAX_LOT.REM_QTY', field: 'remainingQty',
          minWidth: this.getWidth('REM_QTY'),
          width: this.getWidth('REM_QTY'),
          type: 'numericColumn',
          valueFormatter: (param) => this.formatQtyColVal(param)
        }
      ],
      singleClickEdit: true,
      stopEditingWhenGridLosesFocus: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
      onGridReady: (params) => { params.api.sizeColumnsToFit(); },
      onCellClicked: (event) => this.handleOnCellClicked(event),
      onCellEditingStarted: (event) => { this.isEditingInProgress = true; },
      onCellEditingStopped: (event) => this.handleOnCellEditingStopped(event)
    };
    this.gridOptions.defaultColDef = {
      resizable: true,
      headerComponentFramework: PershingGridHeaderComponent
    };
  }

  private getWidth(headerName: string): number {
    switch (headerName) {
      case 'rowGrid':
        return this.activeTheme == "compact" ? 40 : 46;
      case 'headerGrid':
        return this.activeTheme == "compact" ? 45 : 44;
      case 'TRADE_DATE':
        return this.activeTheme == "compact" ? 80 : 110;
      case 'UNIT_COST':
        return this.activeTheme == "compact" ? 98 : 139;
      case 'COST_BASIS':
      case 'SELECTED_QUANTITY':
        return this.activeTheme == "compact" ? 100 : 150
      case 'REM_QTY':
        return this.activeTheme == "compact" ? 100 : 175;
      default:
    }

  }

  formatCoveredInd(params: any): any {
    if ( params.data.coveredInd != null ) {
      switch (params.data.coveredInd) {
        case '01':
        case '02':
          params.value = 'NON_COVERED';
          break;
        case '03':
          params.value = 'PENDING';
          break;
        case '90':
          params.value = 'SHORT';
          break;
        case '91':
          params.value = 'PROVIDE';
          break;
        case 'NA':
          params.value = '';
          break;
        case '':
          params.value = 'COVERED';
          break;
        default:
      }
  } else {
      params.value = 'COVERED';
  }

    params.value = this.getTranslation(params.value);
    return params.value;
  }

  getTranslation(text: string): string {
    let translatedText = '';
    if (text !== '') {
      this.translateService.get('TAX_LOT.COVER_TYPE.' + text).subscribe((translation: string) => {
        translatedText = translation;
    });
    }
    return translatedText;
  }

  formatIndexColVal(param: any): any {
    const checked = (Math.abs(param.data.disposeQty) > 0 || (this.isAvgCost && param.data.selected)) ? 'checked' : '';
    const htmlStr = `<input ${checked} class="tr-TaxLotGrid_Checked" type="checkbox" style="width:15px;height:15px;margin-top:5px" value="${param.node.id}">`;
    if (param.data.lotNo === 'Total') {
      return '';
    } else {
      return htmlStr;
    }
  }

  formatStrPurchaseDateColVal(param: any): any {
    if ('00' === param.data.unitCostInd || '3' === param.data.unitCostInd || '03' === param.data.unitCostInd) {
      return param.value;
    }
    return this.validateUnitCostIndicator(param.data.unitCostInd);
  }
  formatQtyColVal(param: any): any {
    return this.decimalPipe.transform(param.value, '1.4-4', this.language === 'es' ? 'es' : '');
  }

  isEditableDisposeQtyColVal(param: any): any {
    if (param.data.lotNo === 'Total' || param.data.totalCost === 'Total' || this.isAvgCost) {
      return false;
    } else {
      return true;
    }
  }

  formatDisposeQtyColVal(param: any): any {
    const htmlStr = this.isAvgCost ? `<input disabled class="tr-TaxLotGrid_Quantity tr-TaxLotGrid_AvgCost InputLabel" value="${param.value}">` :
      `<input disabled class="tr-TaxLotGrid_Quantity tr-TaxLotGrid_NoAvgCost" value="${param.value}">`;
    if (this.taxlotType === 'disposition') {
      return '';
    } else if (param.data.lotNo === 'Total' || param.data.totalCost === 'Total') {
      return this.decimalPipe.transform(param.value, '1.2-4', this.language === 'es' ? 'es' : '');
    } else {
      return htmlStr;
    }
  }

  formatUnitCostAmtColVal(param: any): any {
    if ('00' === param.data.unitCostInd) {
      return this.decimalPipe.transform(param.value, '1.2-4', this.language === 'es' ? 'es' : '');
    }
    return this.validateUnitCostIndicator(param.data.unitCostInd);
  }
  
  handleOnCellClicked(event: any) {
    if (event.colDef.field === 'index' && event.event?.target.toString() === '[object HTMLInputElement]') {
      const elem = event.event.target as HTMLInputElement;
      if (elem.className === 'tr-TaxLotGrid_Checked') {
        this.processCellClicked(elem); 
      }
    }
  }

  processCellClicked(elem: any) {
      let editRowNode = this.gridOptions.api.getRowNode(elem.value);
      let disposeQtyNewValue = 0;
      if (elem.checked) {
        // mark the row selected, so we can find it even if no disposeQty value has been set
        editRowNode.data.selected = true;
        this.totalSelectedRows++;

        disposeQtyNewValue = this.getDisposeQtyNewValue (editRowNode.data.availableQty);
        if (disposeQtyNewValue === 0) {
          // The user already has the full allocation applied in other rows.
          // Need to unmark this row as selected and decrement the totalSelectedRows count.
          editRowNode.data.selected = false;
          if (this.totalSelectedRows !== 0) {
            this.totalSelectedRows--;
          }
        }

      } else {
        // not checked, so mark the row as not selected
        editRowNode.data.selected = false;
        if (this.totalSelectedRows !== 0 && editRowNode.data.disposeQty !== 0) {
          this.totalSelectedRows--;
        }
      }

      editRowNode.setDataValue('disposeQty', disposeQtyNewValue);
      this.updateRowData(this.rowData, editRowNode);
  }

  getDisposeQtyNewValue (availableQty: any): any {
    let newValue = 0;
    // Avg cost orders never set a dispose qty or allow the user to modify it
    if (!this.isAvgCost) {
      let remainder = this.getRemainder();
      if (Math.abs(availableQty) > remainder) {
        newValue = remainder;
      } else {
        newValue = Math.abs(availableQty);
      }
    }
    return newValue;
  }

  getRemainder(): any {
    let remainder: any;
    if (this.isOrdQty) {
      remainder = this.tradeInfo.ordQty - this.totalSelQty;
    } else if (this.isShareQty) {
      remainder = this.tradeInfo.shareQty - this.totalSelQty;
    }
    //Angular decimal pipe returns string and adds commas to the number according to country locale rules
    //For that purpose we need to remove the commas from formatted number and then parseFloat to get a Float number instead of String.
    remainder = parseFloat(this.decimalPipe.transform(remainder, '1.0-4', this.language === 'es' ? 'es' : '').replace(/,/g, ''));

    return remainder;
  }

  handleOnCellEditingStopped(event: any): any {
    this.isEditingInProgress = false;
    if (
      !event.data.disposeQty || isNaN(event.data.disposeQty) ||
      (Number.parseFloat(event.data.disposeQty) < 0 && this.tradeInfo.transactionType !== TransactionType.BUY_TO_COVER)
    ) {
      event.data.disposeQty = 0;
    }

    // We've established that the value is a valid number, but it's still type string from the Input field.
    // Parse to float, so that we have correct comparisons against 0
    event.data.disposeQty = Number.parseFloat(event.data.disposeQty);

    if (Math.abs(event.data.disposeQty) > Math.abs(event.data.availableQty)) {
      event.data.disposeQty = Math.abs(event.data.availableQty);
    }

    // Check the row data's selected status now vs the new disposeQty value, so we don't
    // change selection state or increment the selected row total again on an already-selected row
    if (!event.data.selected && event.data.disposeQty > 0) {
      event.data.selected = true;
      this.totalSelectedRows++;
    }

    // Likewise, do the same when disposeQty is zero so that we don't mark an already deselected row.
    if (event.data.selected && event.data.disposeQty === 0) {
      event.data.selected = false;
      if (this.totalSelectedRows !== 0) {
        this.totalSelectedRows--;
      }
    }
    this.updateRowData(this.rowData, event);
  }

  private checkForAvgCostOrder() {
    // Orders must have default disposition code "AV" to even have a possibility of being average cost
    if ( this.defaultDispMethodCode !== 'AV' ) {
      return false;
    }

    if ( this.tradeInfo.tradeType === TradeType.MUTUAL_FUND ) {
      // For mutual fund orders, only avg cost orders in currency are flagged, as these need to block lot qty selection
      return this.tradeInfo.tradeInShares === 'false';
    }

    // If the trade type is Equity or Option, automatically NOT an Avg Cost order; only way to be
    // avg cost is if the position is DRIP, and DRIP positions are allowed to edit quantity
    // on all rows.
    if ( this.tradeInfo.tradeType === TradeType.EQUITY || this.tradeInfo.tradeType === TradeType.OPTION ) {
      return false;
    }

    // Option orders can't be DRIP type, and don't have other special conditions we're aware of,
    // so just return true
    return true;
  }

  private checkForMultipleAvgCostBucketSelection() {
    if ( !!this.rowData && this.rowData.length > 0 && this.rowData[0].lotNo === 'Multiple1' && this.rowData[1].lotNo === 'Multiple2' ) {
      // First two rows are avg cost buckets in a mutual fund order.
      // User can only select one of them, whether for a currency or share trade.
      this.showMultipleAvgCostBucketSelectionError = this.rowData[0].selected && this.rowData[1].selected;
    }
  }

  getPinnedBottomData(rowlist) {
    if (this.isRetail) {
      return this.getPinnedBottomDataForRetail(rowlist);
    } else {
      return this.getPinnedBottomDataForProfessional(rowlist);
    }
  }

 getPinnedBottomDataForRetail(rowlist:any){
  return {
    lotNo: '',
    coveredInd: 'NA',
    strPurchaseDate: '',
    availableQty: '',
    totalCost: 'Total',
    disposeQty: rowlist.reduce((sum, a) => {
                if (!isNaN(a.disposeQty)) {
                    return Number((sum + parseFloat(a.disposeQty)).toFixed(4));
                } else {
                  return sum;
                }
            }, 0),
    remainingQty: '',
    selected: false
  };
}

getPinnedBottomDataForProfessional(rowlist:any){
  return {
    lotNo: 'Total',
    strPurchaseDate: '',
    availableQty: rowlist.reduce((sum, a) => {
                  if (!isNaN(a.availableQty)) {
                      return Number((sum + parseFloat(a.availableQty)).toFixed(4));
                  } else {
                    return sum;
                  }
              }, 0),
    disposeQty: rowlist.reduce((sum, a) => {
                if (!isNaN(a.disposeQty)) {
                    return Number((sum + parseFloat(a.disposeQty)).toFixed(4));
                } else {
                  return sum;
                }
            }, 0),
    remainingQty: rowlist.reduce((sum, a) => {
                if (!isNaN(a.remainingQty)) {
                    return Number((sum + parseFloat(a.remainingQty)).toFixed(4));
                } else {
                  return sum;
                }
            }, 0),
    selected: false
  };
}

// Call this Method for each Row
  validateUnitCostIndicator(unitCostIndicator) {
    let defaultVal;
    switch (unitCostIndicator) {
      case '1': {
        defaultVal = UnitCostIndicator.PENDING;
        break;
      }
      case '01': {
        defaultVal = UnitCostIndicator.PENDING;
        break;
      }
      case '2': {
        defaultVal = UnitCostIndicator.PROVIDE;
        break;
      }
      case '02': {
        defaultVal = UnitCostIndicator.PROVIDE;
        break;
      }
      case '3': {
        defaultVal = UnitCostIndicator.GIFTED;
        break;
      }
      case '03': {
        defaultVal = UnitCostIndicator.GIFTED;
        break;
      }
      default: {
        defaultVal = '';
        break;
      }
    }
    return defaultVal;
  }

  private _getTaxlotDetailsSuccess(data) {
    if (data.errorCode === 0 && data.response) {
      if (data.response.returnCode === 0) {
        this.isAllowMethodSelection = data.response.methodSelection;
        this.isAllowLotSelection = data.response.lotSelection;
        if (!this.isAllowMethodSelection) {
          this.dispMethodList = null;
        }
      }
      this.processTaxlotDetailsSuccess(data);
    } else {
      this.logService.error('taxLotService.getTaxlotDetails response error - ', data);
    }
  }

  private processTaxlotDetailsSuccess(data) {
    if (data.response.returnCode === 0 && this.isAllowLotSelection && !!data.response.taxLotDetails) {
      this.altMessage = '';
      this.showConfirmButton = true;
      this.taxLotDetails = data.response.taxLotDetails;
      const rowList = this.getInitRowData(this.taxLotDetails);
      this._refreshGrid(rowList);
      this.containsGiftedLots(rowList);

      if ((!this.isAllowMethodSelection) ||
        (this.tradingDataService.theTaxLot && !this.tradingDataService.theTaxLot.sellMethodCode && this.tradingDataService.theTaxLot.taxLotDetails) ||
        (!!(this.sellTaxlotID || '').trim())) {
        this.taxlotType = 'dateAndQty';
        this.changeTaxlotType();
      } 
    } else {
      this.logService.log('taxLotService.getTaxlotDetails taxLotDetails has error return code, lot selection not allowed, or no lot data - ', data.response);
      this.isAllowLotSelection = false;
      this.altMessage = data.response.returnMsg;
      if (this.tradingDataService.defaultDispositionMethodResp.returnCode !== 0) {
        this.showConfirmButton = false;
      }
    }
  }

  fetchTaxlots() {
    const req: TaxlotDetailsRequest = {
      cusIP: this.tradeInfo.cusip,
      symbol: this.tradeInfo.symId,
      accountNumber: this.tradeInfo.accountNo,
      accountTypeAsEnum: this.tradeInfo.accountType,
      transactionQuantity: this.tradeInfo.tradeType === TradeType.EQUITY || this.tradeInfo.tradeType === TradeType.OPTION ? this.tradeInfo.ordQty : this.tradeInfo.shareQty,
      transactionCurrency: this.tradeInfo.currency,
      transactionAmount: this.tradeInfo.dollarQty,
      transactionType: this.tradeInfo.transactionType,
      tradeType: this.tradeInfo.tradeType,
      enterpriseID: this.tradeInfo.enterpriseID,
      ordDtlKey: this.tradeInfo.ordDtlKey,
      editCntForGTReq: null,
      taxLot: null
    };

    this.taxLotService.getTaxlotDetails(req).subscribe(
      data => this._getTaxlotDetailsSuccess(data),
      error => {
        this.logService.log('taxLotService.getTaxlotDetails service call error - ', error);
      }
    );
  }

  changeTaxlotType() {
    if (this.taxlotType === 'disposition' && this.tradingDataService.defaultDispositionMethodResp.returnCode !== 0) {
      this.showConfirmButton = false;
    } else if (this.taxlotType === 'dateAndQty' && this.altMessage !== '') {
      this.showConfirmButton = false;
    } else {
      this.showConfirmButton = true;
    }
    const rowList = this.getInitRowData(this.taxLotDetails);

    // Re-initialize our total selected rows
    //this.totalSelectedRows = 0;
    if (!!rowList) {
      if (this.taxlotType === 'dateAndQty') {
        if (!!this.tradingDataService.theTaxLot?.taxLotDetails) {
          rowList.forEach((item) => this.processQtyforTaxLotDetails(item));
        } else if (!!(this.sellTaxlotID || '').trim()) {
          rowList.forEach((item) => this.processQtyforSellTaxlotID(item));
        }
      }
      this._refreshGrid(rowList);
    }
  }

  processQtyforTaxLotDetails(item: any): void {
    const taxlot = this.tradingDataService.theTaxLot.taxLotDetails.find((element) => element.lotNo === item.lotNo);
    if (!!taxlot) {
      item.availableQty = taxlot.availableQty;
      item.remainingQty = taxlot.remainingQty;
      item.disposeQty = taxlot.disposeQty;
      item.selected = true;

      // When loading in the saved taxlot info, we need to manually update totalSelectedRows
      // so that we have a correct starting count when the user edits after saving. Otherwise
      // totalSelectedRows will start at zero on a re-edit, blocking the Confirm button from
      // enabling.
      if (item.selected) {
        this.totalSelectedRows++;
      }
    }
  }

  processQtyforSellTaxlotID(item: any): void {

    if (item.lotNo === this.sellTaxlotID) {
      if (this.tradeInfo.tradeType === TradeType.EQUITY) {
        item.disposeQty = this.tradeInfo.ordQty;
      } else if (this.tradeInfo.tradeType === TradeType.MUTUAL_FUND) {
        item.disposeQty = this.tradeInfo.shareQty;
      } else {
        item.disposeQty = this.tradeInfo.ordQty;
      }

      if (item.availableQty > 0) {
        item.remainingQty = item.availableQty - Math.abs(item.disposeQty);
      } else {
        item.remainingQty = item.availableQty + Math.abs(item.disposeQty);
      }
    }
  }

  updateRowData(crtRowData: any, newData: any) {
    crtRowData[newData.rowIndex] = newData.data;

    crtRowData.map((row) => {
      if (row.availableQty > 0) {
        row.remainingQty = row.availableQty - Math.abs(row.disposeQty);
      } else {
        row.remainingQty = row.availableQty + Math.abs(row.disposeQty);
      }
      return row;
    });

    // Since the enclosing method is outside of any Grid API method, verify the API still exists before calling it.
    if ( !!this.gridOptions.api ) {
      this.gridOptions.api.refreshCells();
    }
    this._refreshGridTotal(this.rowData);
  }

  _refreshGrid(newRowList: any) {
    this._refreshGridTotal(newRowList);

    this.rowData = newRowList;
  }

  _refreshGridTotal(newRowList: any) {
    this.totalRow = this.getPinnedBottomData(newRowList);
    this.totalSelQty = Math.abs(this.totalRow.disposeQty);

    this.pinnedBottomRowData = [];
    this.pinnedBottomRowData.push(this.totalRow);

    // Since the enclosing method is outside of any Grid API method, verify the API still exists before calling it.
    if (!!this.gridOptions.api) {
      this.gridOptions.api.setPinnedBottomRowData(this.pinnedBottomRowData);
    }

    if ( this.tradeInfo.tradeType === TradeType.MUTUAL_FUND && this.isAvgCost ) {
      // Only have to check for multiple avg cost bucket selection when it's a currency order.
      // isAvgCost is only set to true for currency orders, so easy to limit. :)
      this.checkForMultipleAvgCostBucketSelection();
    }
    this.showLesserQtyWarning = this.tradingEntitlements.isRetailUser && this.totalSelQty > 0 &&
    ((this.tradeInfo.tradeType === TradeType.EQUITY || this.tradeInfo.tradeType === TradeType.OPTION) && !this.isAvgCost && this.tradeInfo.ordQty > this.totalSelQty) ||
    (this.tradeInfo.tradeType === TradeType.MUTUAL_FUND && !this.isAvgCost && this.tradeInfo.shareQty > this.totalSelQty);

    // If our selected qty exceeds the order qty / share qty, show the overallation msg
    this.showOverallocationError =
      ((this.tradeInfo.tradeType === TradeType.EQUITY || this.tradeInfo.tradeType === TradeType.OPTION) && (!this.isAvgCost && this.totalSelQty > this.tradeInfo.ordQty)) ||
      this.tradeInfo.tradeType === TradeType.MUTUAL_FUND && (!this.isAvgCost && this.totalSelQty > this.tradeInfo.shareQty);
  }

  containsGiftedLots(newRowList: any) {
    if (!!newRowList.find(a => (a.unitCostInd === '3' || a.unitCostInd === '03'))) {
      this.setDisclaimers(true);
    }
  }

  getInitRowData(taxLotDetails) {
    const rowList = [];
    
    if (taxLotDetails) {
      taxLotDetails.forEach((taxlot: TaxLotDetail, idx: number) => {
        const row: any = taxlot;
        row.index = idx + 1;

        row.disposeQty = 0;
        row.remainingQty = row.availableQty - Math.abs(row.disposeQty);

        rowList.push(row);
      });
    }
    return rowList;
  }

  openAlertMessageDialogChooseGreaterQty() {
    let message: string;
    if (this.tradeInfo.tradeType !== 'OPTION') {
        message = 'TAX_LOT.CHOSEN_GREATER_QUANTITY_360';
    } else {
        message = 'TAX_LOT.CHOSEN_GREATER_QUANTITY_OPTIONS_360';
    }

    const alertMessageDialogRef = this.dialog.open(AlertMessageDialogComponent, {
      panelClass: 'modal',
      maxWidth: '40%',
      disableClose: true,
      autoFocus: false,
      data: {
        msgHeaderLabel: '',
        msgBodyLabel: message,
        msgLevel: ALERT_MESSAGE_LEVEL.warn,
        confirmButtonLabel: 'TAX_LOT.YES',
        cancelButtonLabel: 'TAX_LOT.NO',
        activeTheme:this.activeTheme
      }
    });

    this.processAfterClosed(alertMessageDialogRef);
  }

  openAlertMessageDialogLotDisposalMethod() {
    const alertMessageDialogRef = this.dialog.open(AlertMessageDialogComponent, {
      panelClass: 'modal',
      maxWidth: '40%',
      disableClose: true,
      autoFocus: false,
      data: {
        msgHeaderLabel: '',
        msgBodyLabel: 'TAX_LOT.LOT_DISPOSAL_METHOD',
        msgLevel: ALERT_MESSAGE_LEVEL.warn,
        confirmButtonLabel: 'TAX_LOT.YES',
        cancelButtonLabel: 'TAX_LOT.NO',
        activeTheme:this.activeTheme
      }
    });
    this.processAfterClosed(alertMessageDialogRef);
  }

  processAfterClosed(alertMessageDialogRef:any) {
    alertMessageDialogRef.afterClosed().subscribe((data: any) => {
      console.log('proceeding : ', data);
      if (data) {
        this.submitTaxlot();
      }
    });
  }

  openAlertMessageDialogExitLot() {
    const alertMessageDialogRef = this.dialog.open(AlertMessageDialogComponent, {
      panelClass: 'modal',
      maxWidth: '40%',
      disableClose: true,
      autoFocus: false,
      data: {
        msgHeaderLabel: '',
        msgBodyLabel: 'TAX_LOT.EXIT_LOT',
        msgLevel: ALERT_MESSAGE_LEVEL.warn,
        confirmButtonLabel: 'TAX_LOT.YES',
        cancelButtonLabel: 'TAX_LOT.NO',
        activeTheme:this.activeTheme
      }
    });

    alertMessageDialogRef.afterClosed().subscribe((data) => {
      console.log('proceeding : ', data);
      if (data) {
        this.submitSuccessEmitter.emit();
      }
    });
  }

  checkBeforeSubmit() {
    if ( this.isEditingInProgress && this.editCheckCount <= 2 ) {
      // Allow the editing to finish (blur has already happened), and call this again after a short delay.
      // BUT, only try this twice, because if the user clicks on one of the other qty fields in the grid
      // after entering a value in another qty field, they will set the "editing in progress" flag to true
      // even though the field they just clicked isn't active / showing edit mode.
      timer(50, null).subscribe(() => { this.checkBeforeSubmit(); });
      this.editCheckCount++;
      return;
    } else {
      this.isEditingInProgress = false;
      this.editCheckCount = 0;
    }

    // Since we might have come into this function through the timer, we have to check for possible overallocation
    if ( this.showOverallocationError ) {
      return;
    }

    if (this.taxlotType === 'disposition') {
      this.openAlertMessageDialogLotDisposalMethod();
    } else {
      if (this.taxlotType !== 'disposition' &&
        (((this.tradeInfo.tradeType === TradeType.EQUITY || this.tradeInfo.tradeType === TradeType.OPTION) && !this.isAvgCost && this.tradeInfo.ordQty > this.totalSelQty) ||
          (this.tradeInfo.tradeType === TradeType.MUTUAL_FUND && !this.isAvgCost && this.tradeInfo.shareQty > this.totalSelQty))) {
          this.handleLesserQtyWarning();
      } else {
        this.submitTaxlot();
      }
    }
  }

  handleLesserQtyWarning() {
    if (this.showLesserQtyWarning) {
      this.submitTaxlot();
    } else {
      this.openAlertMessageDialogChooseGreaterQty();
    }
  }

  submitTaxlot() {
    if (this.tradeInfo) {
      this.isSpinnerLoading = true;
      const taxlotReq = this._createTaxlotRequestObj();
      this.isSubmitFailed = false;
      if (this.taxlotType === 'disposition') {
        taxlotReq.taxLot = {
          sellMethodCode: this.dispMethodCode
        };
      } else {  // this.taxlotType === 'dateAndQty'
        const reqTaxLotDetails = [];
        this.rowData.forEach((row, idx) => {
          if ( row.selected ) {
            row.disposeQty = this.tradeInfo.transactionType !== TransactionType.BUY_TO_COVER ? Math.abs(row.disposeQty) : 0 - Math.abs(row.disposeQty);
            reqTaxLotDetails.push(row);
          }
        });

        taxlotReq.taxLot = {
          sellMethodCode: null,
          taxLotDetails: reqTaxLotDetails
        };
      }

      this.taxLotService.submitTaxlot(taxlotReq).subscribe(
        data => this.taxlotSubmissionSuccess(data),
        error => {
          this.logService.error('taxlot submit http error - ', error);
          this.isSpinnerLoading = false;
        }
      );
    } else {
      this.logService.error('Trade info is unavailable - ', this.tradeInfo);
    }
  }

  private _createTaxlotRequestObj(): TaxlotSubmissionRequest {
    const taxlotReq: TaxlotSubmissionRequest = {} as TaxlotSubmissionRequest;

    taxlotReq.enterpriseId = this.tradeInfo.enterpriseID;
    taxlotReq.quote = {
      cusip: this.tradeInfo.cusip,
      symId: this.tradeInfo.symId
    };
    taxlotReq.tradeType = this.tradeInfo.tradeType;
    taxlotReq.account = {
      acctNum: this.tradeInfo.accountNo
    };
    taxlotReq.accountType = this.tradeInfo.accountType;
    taxlotReq.transactionType = this.tradeInfo.transactionType;
    if (taxlotReq.tradeType === TradeType.EQUITY || taxlotReq.tradeType === TradeType.OPTION) {
      taxlotReq.ordQty = this.tradeInfo.ordQty;
      taxlotReq.shareQty = null;
      taxlotReq.dollarQty = null;
      taxlotReq.orderType = this.tradeInfo.orderType;
      taxlotReq.duration = this.tradeInfo.duration;
    }

    if (taxlotReq.tradeType === TradeType.MUTUAL_FUND) {
      if (this.tradeInfo.transactionType === TransactionType.REDEEM) {
        if ( this.isBdUser ) {
          taxlotReq.cdscWaiver = CDSCWaiver.NO;
        }
        taxlotReq.redemptionFeeWaiver = this.tradingEntitlements.isProfessionalUser ? RedemptionFeeWaiver.NO : null;
      } else {
        taxlotReq.cdscWaiver = null;
        taxlotReq.redemptionFeeWaiver = null;
        taxlotReq.exchangeMutualFund = {
          symbol: this.tradeInfo.exchangeMutualFundSymId,
          cusip: '',
          securityIdentifier: ''
        };
      }
      taxlotReq.dvre = this.tradeInfo.mutualFundDvre;
      taxlotReq.ordQty = null;
      if (this.isShareQty) {
      taxlotReq.shareQty = this.tradeInfo.shareQty;
      taxlotReq.dollarQty = null;
      } else if (this.isDollarQty) {
        taxlotReq.shareQty = null;
        taxlotReq.dollarQty = this.tradeInfo.dollarQty;
      }
      taxlotReq.tradeInShares = this.tradeInfo.tradeInShares;
      taxlotReq.mutualFund = {
        symbol: this.tradeInfo.mutualFundSymId,
        cusip: '',
        securityIdentifier: ''
      };
    }

    return taxlotReq;
  }

  taxlotSubmissionSuccess(resp) {
    if (resp.errorCode === 0 && resp.response) {
      this.isSpinnerLoading = false;
      const respBody = resp.response;

      if (Array.isArray(respBody.errors) && respBody.errors.length > 0) {
        this.submissionErrors = respBody.errors;
      } else {
        this.submissionErrors = [];
        if (respBody.taxLot) {
          if (respBody.taxLot.returnCode === 0 && respBody.taxLot.returnMsg !== null && respBody.taxLot.returnMsg !== '') {
              this.isSubmitFailed = true;
              this.altMessage = respBody.taxLot.returnMsg;
              return;
          }
          
          this.tradingDataService.theTaxLot = respBody.taxLot;
          this.submitSuccessEmitter.emit();
        }
      }
    }
  }

  setDisclaimers(containsGiftedLots: any) {
    if (this.tradeInfo.tradeType === TradeType.MUTUAL_FUND) {
      this.showDisclaimer1 = true;
      this.showDisclaimer2 = true;
      if (this.defaultDispMethodCode === 'AV') {
        this.showDisclaimerAvgCost4 = true;
      }
      if (containsGiftedLots) {
        this.showDisclaimerGiftCost5 = true;
      }
    } else {
      this.showDisclaimer1 = true;
      this.showDisclaimer2 = true;
      this.showDisclaimerEquity3 = true;
      if (this.defaultDispMethodCode === 'AV') {
        this.showDisclaimerAvgCost4 = true;
      }
      if (containsGiftedLots) {
        this.showDisclaimerGiftCost5 = true;
        if (this.isDriPPositionInd) {
          this.showDisclaimerAvgDRIP6 = true;
        }
      }
    }
  }

}
